// extracted by mini-css-extract-plugin
export var container = "IconText-module__container___9pn0K";
export var icon = "IconText-module__icon___2lSCQ";
export var label = "IconText-module__label___SkTCC";